// extracted by mini-css-extract-plugin
export default {"finalScreen":"final-quiz-screen_finalScreen__MZJiK","contentContainer":"final-quiz-screen_contentContainer__8r3uv"};